import React, { Component } from "react";
import { connect } from "react-redux";
import { setMenuLeftContent, setMenuTopIndex } from "./../../redux/actions/menuActions";

import { changeLeftMenuItem, changeLeftMenuSubItem, init, injectPermalinkData } from "./actions/stats";
import PerformanceContainer from "./containers/views/PerformanceContainer";
import DashboardContainer from "./containers/views/DashboardContainer";
import HomeContainer from "./containers/views/HomeContainer";
import TableContainer from "./containers/views/TableContainer";
import LeftMenu from "./components/LeftMenu/LeftMenu";
import SummaryContainer from "./containers/summary/Summary";
import _ from "lodash";
import { kpis as KPIS } from "./../../configs/kpis";
import { withRouter } from "react-router-dom";
import permalink from "./permalink";
const getMenuItems = (kpis = []) => {
  const menuItems = [];
  let prefixKey = "@";

  kpis.map(v => {
    v.dashboard_priority = v.dashboard_priority || v.priority;

    if (!v.dashboard_priority) {
      v.dashboard_priority = 10000;
    }
  });

  kpis = _.orderBy(kpis, ["dashboard_priority", "id"], ["ASC", "ASC"]);

  for (let i = 0; i < kpis.length; i++) {
    prefixKey = "@";
    const kpi = kpis[i] || {};
    const kpiClientIds = kpi.client_id || [];
    const clientId = kpiClientIds[0];
    //TODO remove
    let V2Only =
      (kpi.id !== KPIS.DN && kpi.display_group && kpi.display_group.indexOf("DN") !== -1) ||
      (kpi.id !== KPIS.MEA &&
        kpi.display_group &&
        kpi.display_group.indexOf("MEA") !== -1 &&
        [1, 17].indexOf(clientId) !== -1) ||
      (kpi.id !== KPIS.PLV &&
        kpi.display_group &&
        kpi.display_group.indexOf("PLV") !== -1 &&
        [1, 17].indexOf(clientId) !== -1) ||
      (kpi.id !== KPIS.NB_VENDEURS && kpi.display_group && kpi.display_group.indexOf("VENDEURS") !== -1) ||
      //(kpi.id !== KPIS.PDL && kpi.display_group && kpi.display_group.indexOf("PDL") !== -1) ||
      (kpi.id !== KPIS.PDL_BRAND &&
        kpi.id !== KPIS.PDL &&
        kpi.id !== KPIS.PDL_FAMILY &&
        kpi.display_group &&
        kpi.display_group.indexOf("PDL") !== -1) ||
      (kpi.id !== KPIS.VISITES &&
        kpi.id !== KPIS.MEAN_VISIT &&
        kpi.display_group &&
        kpi.display_group.indexOf("VISITES") !== -1);
    if (!kpi.dashboard_display || V2Only) {
      continue;
    }
    const displayGroup = kpi.display_group || [];

    if (displayGroup.length === 0) {
      menuItems.push({
        label: kpi.long_label,
        type: "kpi",
        key: prefixKey + kpi.long_label + kpi.id,
        kpi
      });
    } else {
      let currentItem = menuItems;
      for (let j = 0; j < displayGroup.length; j++) {
        const displayGroupElement = displayGroup[j];
        let menuItem = currentItem.find(v => v.label === displayGroupElement);

        if (menuItem) {
          currentItem = menuItem.submenus || [];
        } else {
          const submenu = {
            label: displayGroupElement,
            type: "menu",
            key: prefixKey + displayGroupElement + kpi.id,
            submenus: []
          };
          currentItem.push(submenu);
          currentItem = submenu.submenus;
        }
        prefixKey += "@";
        //add kpi
        if (j === displayGroup.length - 1) {
          currentItem.push({
            label: kpi.long_label,
            type: "kpi",
            key: prefixKey + kpi.long_label + kpi.id,
            kpi
          });
        }
      }
    }
  }
  // console.log("@@@@", menuItems);
  return menuItems;
};

/**
 * Render stats content (dashboard/perf/data)
 * @param props
 * @return {*}
 * @constructor
 */
const StatsContent = (props = {}) => {
  if (props.view === "home") return <HomeContainer />;
  if (props.view === "dashboard") return <DashboardContainer />;
  if (props.view === "performance") return <PerformanceContainer />;
  if (props.view === "table") return <TableContainer />;
  if (props.view === "summary") return <SummaryContainer />;
};
class Stats extends Component {
  componentDidMount() {
    const location = this.props.location || {};
    const search = location.search || "";
    const params = new URLSearchParams(search);
    const query = params.get("query");
    let queryData;

    if (query) {
      queryData = permalink.urlQueryToData(query);
      this.props.injectPermalinkData(queryData);
    }

    this.props.init(queryData);
    this.props.setMenuTopIndex("stats");
  }

  renderSubMenus() {
    const kpis = this.props.kpis;
    const menuItems = getMenuItems(kpis);
    this.props.setMenuLeftContent({ display: true, classes: "custom-stats", content: <LeftMenu items={menuItems} /> });
    //this.props.setMenuLeftContent(menu);
  }

  renderView() {
    if (this.props.view === "home") return <HomeContainer />;
    if (this.props.view === "dashboard") return <DashboardContainer />;
    if (this.props.view === "performance") return <PerformanceContainer />;
    if (this.props.view === "table") return <TableContainer />;
  }
  render() {
    const statsQuery = permalink.dataToUrlQuery(permalink.getStateData(this.props.statsState));
    window.history.replaceState(null, null, `/stats?query=${statsQuery}`);
    this.renderSubMenus();
    return <StatsContent view={this.props.view} />;
  }
}

//REDUX
const mapStateToProps = (state, ownProps) => {
  return {
    kpis: state.stats.kpis || [],
    zone: state.stats.zones.z1,
    view: state.stats.view,
    statsState: state.stats
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: queryData => {
      dispatch(init(queryData));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },

    changeLeftMenuItem: leftMenuItem => {
      dispatch(changeLeftMenuItem(leftMenuItem));
    },
    changeLeftMenuSubItem: item => {
      dispatch(changeLeftMenuSubItem(item));
    },
    injectPermalinkData: data => {
      dispatch(injectPermalinkData(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Stats));



// WEBPACK FOOTER //
// src/modules/stats/index.js